<div class="row text-center justify-content-lg-center padding-10">
  <div class="row footer-width">
    <div class="col-lg-6 6 text-left">
      <img src="assets/img/UnityC_RGB_app_72_193x47.png" class="img-fluid" alt="UnityC Logo">
    </div>
    <div class="col-lg-6 6 padding-top-20 text-right">
      <div>
        &copy; Copyright {{currentYear}} Dye & Durham Corporation
      </div>
    </div>
  </div>
</div>
